import {IToothlikeNameProvider} from '@data/providers/DentalNotationProvider/IToothlikeNameProvider';

export class ToothlikeFdiNameProvider implements IToothlikeNameProvider {
  getName(toothNumber: number): string {
    return toothNumber.toString();
  }
}